"use strict";
class AlarmListComponent {
    constructor(_inaxAlarm, _inaxTranslate) {
        this._inaxAlarm = _inaxAlarm;
        this._inaxTranslate = _inaxTranslate;
        this._filter = "";
        this._currentSortOrder = "";
        this._entriesPerPage = 20;
        this._currentPage = 1;
        this.title = "";
        this.firstPage = 1;
        this.numberOfAlarms = 0;
        this.alarms = [];
        this.columnTitle = new Map();
    }
    get dataChangeIsAvailable() {
        return this._inaxAlarm.dataChangeIsAvailable;
    }
    get currentPage() {
        return this._currentPage;
    }
    get skip() {
        return (this.currentPage - 1) * this._entriesPerPage;
    }
    get entriesPerPage() {
        return this._entriesPerPage;
    }
    get numberOfPages() {
        return Math.floor(this.numberOfAlarms / this._entriesPerPage) + 1;
    }
    ngOnInit() {
        //subscribe to the services
        this._translateSubscription = this._inaxTranslate.ChangeEvent.subscribe(lng => this.updateAlarms());
        this._alarmSubscription = this._inaxAlarm.ChangeEvent.subscribe((alarmListEvent) => {
            this.updateAlarms();
        });
        this.updateAlarms();
    }
    ngOnDestroy() {
        //unsubscribe from the services
        if (this._alarmSubscription != null)
            this._alarmSubscription.unsubscribe();
        if (this._translateSubscription != null)
            this._translateSubscription.unsubscribe();
    }
    sortBy(propertyName) {
        if (propertyName == null)
            return;
        if (this._currentSortOrder.indexOf(propertyName) > -1) {
            if (this._currentSortOrder.indexOf("desc") > -1) {
                this._currentSortOrder = "";
                this.columnTitle[propertyName] = "";
            }
            else {
                this._currentSortOrder = propertyName + " desc";
                this.columnTitle[propertyName] = " (desc)";
            }
        }
        else {
            var val = this._currentSortOrder.replace(' desc', '');
            this.columnTitle[val] = "";
            this._currentSortOrder = propertyName;
            this.columnTitle[propertyName] = " (asc)";
        }
        this.updateAlarms();
    }
    onpageChanged(page) {
        this._currentPage = page;
        this.updateAlarms();
    }
    lineColor(entry) {
        return entry.LineColore;
    }
}
exports.AlarmListComponent = AlarmListComponent;
